import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMediaQuery } from "_common/component/MediaQueryProvider";
import { useStores } from "_common/hooks";
import { Link } from "react-router-dom";
import { formatNumber } from "_common/utils/formatValue";

const FundHistory = observer(() => {
  const {
    authStore: { ieo },
  } = useStores();
  const { isMobile } = useMediaQuery();

  return (
    <div className="orebox2" id="zlbox">
      <div className="content">
        <span className="fzmm fcc">Hiện tại chưa có</span>
      </div>
    </div>
  );
});

export default FundHistory;
